// 五端服务切换相关工具：协议解析、目标地址解析、跳转地址拼接
// 说明：仅承载解析/拼接逻辑，不涉及具体业务与登录态清理（由页面负责）

// 解析请求 baseURL 的协议：http: 为测试服，https: 为正式服，异常返回 null
export function getProtocol(url) {
  const match = (url || "").match(/^([^:]+:)(\/\/)(.*)/);
  return match ? match[1] : null;
}

// 根据当前协议，从 { test, formal } 中取出目标基础地址；缺失时返回空串
export function resolveServiceUrl(target, protocol) {
  if (!target) return "";
  if (protocol === "http:") return target.test || "";
  if (protocol === "https:") return target.formal || "";
  return "";
}

// 拼接携带登录态的服务跳转地址：把 token 附带 type/sceneId/sceneName 后编码到 data 参数
export function buildSwitchUrl(token, sceneId, sceneName, baseUrl) {
  const payload = Object.assign({}, token, {
    type: "cut",
    sceneId: sceneId,
    sceneName: sceneName
  });
  const encoded = encodeURIComponent(JSON.stringify(payload));
  return `${baseUrl}?data=${encoded}`;
}
